export default "/images/vendor/chocolat/dist/right.png?9d73f56b1cd4bc2ba9e6012829e32681";